var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_futureshop2.html';
var html = "<span translate=sites.campaigns.edit.instruction.futureshop2></span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/instruction_futureshop2.html
// module id = 1392
// module chunks = 0